var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58398 10.0327V8.79937C7.58398 7.20771 8.70898 6.56604 10.084 7.35771L11.1507 7.97437L12.2173 8.59104C13.5923 9.38271 13.5923 10.6827 12.2173 11.4744L11.1507 12.091L10.084 12.7077C8.70898 13.4994 7.58398 12.8494 7.58398 11.266V10.0327Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 18.366C14.6017 18.366 18.3327 14.635 18.3327 10.0327C18.3327 5.4303 14.6017 1.69934 9.99935 1.69934C5.39698 1.69934 1.66602 5.4303 1.66602 10.0327C1.66602 14.635 5.39698 18.366 9.99935 18.366Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.8fe4108fa432fbcd2c0bdbaffa447bfb.svg";
export { ForwardRef as ReactComponent };